<section class="breadcrumbs_common bg_img pos_relative">
  <div class="overlay-innerpage"></div>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumbs_content">
          <h2 class="text-white">About Institute</h2>
          <ul class="breadcrumb">
            <li>
              <a routerLink="/">Home</a>
            </li>/
            <li class="active">
              <a routerLink="javascript:void(0);">About Institute</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="about-institute ptb--100">
  <div class="container">
    <div class="row g-lg-5">
      <div class="col-lg-6">
        <p>With a vision to achieve excellent standards of quality education by keeping pace with rapidly changing
          technologies and create technical manpower of global standards with capabilities of accepting new challenges,
          the founder of RGI group Lt. Shri Gyanchandji H. Raisoni was a visionary and an inspiration. He aspired for a
          group of institutions impeccable, excellent and powerful in the context of the Indian society. It is his dream
          which has been accomplished in the form of The Raisoni Group of Institutions. They took initiative to impart
          quality education with easy access to the young generation in rural area and the mission for excellence in
          education started under the name of G H Raisoni College of Arts, Commerce and Science, Pune in 2007 under the
          aegis of RGI Campus Pune, affiliated to Savitribai Phule Pune University and recognized by the Government of
          Maharashtra.</p>

        <p>The college is located in Wagholi, Wagholi is historically known as home of Maratha Warrior Sardar Pilajirao
          Changojirao Jadhav. With this great heritage, the college also endeavors to delegate knowledge in a peaceful
          environment by committed, passionate, dedicated, innovative and experienced faculty through active learning,
          field visits, experts’ guidance, training programs, research guidance and support and continuous assessment.
          The efforts are made to create a world-class infrastructure with latest technological advancements.</p>

      </div>
      <div class="col-md-5 mb-3 ms-md-3">
        <img src="{{baseUrl}}/abt-right-thumb.webp" alt="About Institute | GHRCACS, PUNE" class="img-fluid overlay w-100">
      </div>
      <div class="col-md-12">
        <p>GHRCACS has an excellent reputation as a leader &amp; pioneer in spreading education to wide community with
          it's rich academic and cultural heritage which contributes in developing noble citizen to the society. It has
          committed to engage alumni, students, faculties and other stakeholders collectively to achieve the educational
          goals.</p>
        <p>The college G H Raisoni College of Arts, Commerce and Science offers undergraduate programs- Bachelor of
          Commerce(B.Com), Bachelor of Business Administration(BBA), Bachelor of Business Administration- Computer
          Application(BCA), Bachelor of Science-Computer Science(B.Sc-CS),BCA(Science), BBA(IB), BSc(IT).</p>
        <p>The college recurrently organizes curricular, co-curricular and extra-curricular activities for the holistic
          development of the students. The advanced resources, facilities and special guidance programs are made
          available to succeed in the competition, to gain deep knowledge, to develop employability potentials and to
          meet with industrial requirements. The college also provides the best placement opportunities to the students.
        </p>
        <p>The college, Principal, Vice-Principal and staff members have received various prestigious awards, prizes and
          honors for their magnificent contribution in imparting knowledge, inculcating life skills, developing research
          skills and providing the best placement.</p>
      </div>
    </div>
  </div>
</section>
